const ZendeskCategories = {
    SHIPPER: '4415399989777',
    PROVIDER: '4415411599889',
};

export { ZendeskCategories };
